import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { z } from "zod";
import { withInviteTokenSearch } from "@/lib/pending-pricing-invite";
import { orpcClient } from "@/lib/auth-client";
import { DuplicateAccountWarningModal } from "@/components/duplicate-account-warning-modal";
import { SecurityPage } from "./security";

export const Route = createFileRoute("/enroll-mfa")({
  validateSearch: withInviteTokenSearch({
    redirect_uri: z.string().optional(),
  }).parse,
  component: EnrollMfaPage,
});

function EnrollMfaPage() {
  const { redirect_uri } = Route.useSearch();
  const navigate = useNavigate();

  // AUTH-154: warn duplicate-flagged accounts BEFORE forced MFA enrollment —
  // enrolling a factor on an account the user is about to abandon is the most
  // annoying version of the late warning. A session exists here (the index
  // decision tree only routes factor-less authenticated users to this page).
  const duplicateQuery = useQuery({
    queryKey: ["auth", "duplicate-check"],
    queryFn: () => orpcClient.auth.checkDuplicate(),
    retry: false,
  });
  const [duplicateAcked, setDuplicateAcked] = useState(false);
  const showDuplicateWarning = !!duplicateQuery.data?.isDuplicate && !duplicateAcked;

  return (
    <>
      <DuplicateAccountWarningModal
        open={showDuplicateWarning}
        canonicalEmail={duplicateQuery.data?.duplicateOfEmail ?? null}
        onProceed={() => setDuplicateAcked(true)}
        onUseOtherAccount={() => navigate({ to: "/login", search: { redirect_uri } })}
        data-testid="enroll-mfa-duplicate-account-dialog"
      />
      <SecurityPage setup redirect_uri={redirect_uri} />
    </>
  );
}
